import { render, staticRenderFns } from "./Skull.vue?vue&type=template&id=3eb7b29a&scoped=true&"
import script from "./Skull.vue?vue&type=script&lang=js&"
export * from "./Skull.vue?vue&type=script&lang=js&"
import style0 from "./Skull.vue?vue&type=style&index=0&id=3eb7b29a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb7b29a",
  null
  
)

export default component.exports